/*
 * @Author: 刘小博
 * @Date: 2023-02-07 14:28:18
 * @LastEditTime: 2023-02-19 18:24:05
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: /p2ps_vip_web/src/router/behavior-manage/work-center/modules/visitTargetRouter.js
 * 拜访指标
 */
const visitTargetRouter = [
  // 1 拜访指标 2 协防指标 3医生
  {
    path: '/behaviorManage/visit-index/:meta_type',
    name: 'behaviorManageVisitIndex',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageVisitIndex" */
      //   '@/views/behaviorManage/indicator/VisitIndex.vue'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManageVisitIndex" */
        '@/views/behavior-manage/work-center/visit-target/visit-cooperative-doctorTarget/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访指标', //二级菜单
      isMoreMeta: true,
      1: {
        title: '拜访指标',
      },
      2: {
        title: '协访指标',
      },
      3: {
        title: '医生指标',
      },
    },
  },
  // 1 拜访指标分配 2 协访指标分配 3 医生指标分配
  {
    path: '/behaviorManage/index-allocation/:meta_type',
    name: 'behaviorManageIndexAllocation',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageIndexAllocation" */
      //   '@/views/behaviorManage/indicator/IndexAllocation.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageIndexAllocation" */
        '@/views/behavior-manage/work-center/visit-target/visit-cooperative-doctorTarget/Distribution.vue'
      ),   //新迁移文件
    meta: {
      SecondaryMenu: '拜访指标', //二级菜单
      isMoreMeta: true,
      1: {
        title: '拜访指标分配',
        breadcrumb: [{
          title: '拜访指标',
          name: 'behaviorManageVisitIndex',
        },],
      },
      2: {
        title: '协访指标分配',
        breadcrumb: [{
          title: '协访指标',
          name: 'behaviorManageVisitIndex',
        },],
      },
      3: {
        title: '医生拜访指标分配',
        breadcrumb: [{
          title: '医生指标',
          name: 'behaviorManageVisitIndex',
        },],
      },
    },
  },
  // 1 拜访指标详情 2 协访指标详情 3 医生指标详情
  {
    path: '/behaviorManage/visit-index-details/:meta_type/:id/:year/:cls',
    name: 'behaviorManageVisitIndexDetails',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageVisitIndexDetails" */
      //   '@/views/behaviorManage/indicator/VisitIndexDetails.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageVisitIndexDetails" */
        '@/views/behavior-manage/work-center/visit-target/visit-cooperative-doctorTarget/Detail.vue'
      ),   //新迁移文件
    meta: {
      SecondaryMenu: '拜访指标', //二级菜单
      isMoreMeta: true,
      1: {
        title: '拜访指标详情',
        breadcrumb: [{
          title: '拜访指标',
          name: 'behaviorManageVisitIndex',
        },],
      },
      2: {
        title: '协访指标详情',
        breadcrumb: [{
          title: '协访指标',
          name: 'behaviorManageVisitIndex',
        },],
      },
      3: {
        title: '医生指标详情',
        breadcrumb: [{
          title: '医生指标',
          name: 'behaviorManageVisitIndex',
        },],
      },
    },
  },
  // 医院开发指标
  {
    path: '/behaviorManage/hospitalTarget',
    name: 'behaviorManageHospitalTarget',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageVisitIndex" */
      //   '@/views/behaviorManage/indicator/HospitalTarget.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageVisitIndex" */
        '@/views/behavior-manage/work-center/visit-target/hospital-devop-target/Page.vue'
      ), //新迁移文件
    meta: {
      title: '医院开发指标', //二级菜单
      isMoreMeta: true,
    },
  },
  // 医院开发指标分配
  {
    path: '/behaviorManage/hospitalTargetImport',
    name: 'behaviorManageHospitalTargetImport',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageVisitIndex" */
      //   '@/views/behaviorManage/indicator/HospitalTargetImport.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageVisitIndex" */
        '@/views/behavior-manage/work-center/visit-target/hospital-devop-target/Distribution.vue'
      ), //新迁移文件
    meta: {
      title: '医院开发指标分配', //二级菜单
      isMoreMeta: true,
      breadcrumb: [{
        title: '医院开发指标',
        name: 'behaviorManageHospitalTarget',
      },],
    },
  },
]
export default visitTargetRouter